const apiUrl = process.env.REACT_APP_API_URL;
export const PostRebutFraccionat = async ( rebut: any , page : string , id_usu_log : string, numero_fracio : number) => {
    try {
        const response = await fetch(`${apiUrl}:8073/rebuts/fraccionat/${id_usu_log}?fraccio=${numero_fracio}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(rebut)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
